import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, RedirectToSignIn } from "@clerk/react";
import { Home } from "@/pages/Home";
import { AppHome } from "@/pages/AppHome";
import { MarketingOnly } from "@/pages/MarketingOnly";

const hasClerk = Boolean(
  (import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined)?.trim()
);

function ProtectedApp() {
  return (
    <>
      <Show when="signed-in">
        <AppHome />
      </Show>
      <Show when="signed-out">
        <RedirectToSignIn />
      </Show>
    </>
  );
}

export default function App() {
  if (!hasClerk) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MarketingOnly />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/app" element={<ProtectedApp />} />
        <Route path="/app/*" element={<ProtectedApp />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
